import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Reusable per-page SEO tags. Drop `<PageSeo ... />` at the top of any page's
 * returned JSX. Covers title, description, canonical, and OG/Twitter cards.
 */
const SITE = 'https://cashifygcmart.com';

const PageSeo = ({
  title,
  description,
  path,
  image = `${SITE}/images/og-cover.jpg`,
  type = 'website',
  noindex = false,
}) => {
  const canonical = `${SITE}${path || '/'}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'}
      />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="CashifyGCMart" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default PageSeo;
